module.exports = __webpack_public_path__ + "static/img/4.3fa4ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/4.png
// module id = H8uR
// module chunks = 0